import { render, staticRenderFns } from "./FilmWalletModals.vue?vue&type=template&id=137b4da6"
import script from "./FilmWalletModals.vue?vue&type=script&lang=js"
export * from "./FilmWalletModals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports